import { render, staticRenderFns } from "./BasePageLayout.vue?vue&type=template&id=6d613080&scoped=true"
import script from "./BasePageLayout.vue?vue&type=script&lang=js"
export * from "./BasePageLayout.vue?vue&type=script&lang=js"
import style0 from "./BasePageLayout.vue?vue&type=style&index=0&id=6d613080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d613080",
  null
  
)

export default component.exports